import { actionCreatorFactory } from 'typescript-fsa';
import { DesignSet, ArrowType, OrderType } from '@app/react/const/type';

const actionCreator = actionCreatorFactory();

export interface IYourDesignDeleteParam {
    arrowType: ArrowType;
    orderType: OrderType;
    item: DesignSet;
}

// dialogInfo is Enables open dialog via middleware
export const yourDesignDeleteAction = actionCreator<IYourDesignDeleteParam>(
    'yourDesignDeleteAction',
);
